import * as Phaser from "phaser"
import { THEME } from "./core/theme"
import { GAME_HEIGHT, GAME_WIDTH } from "./data/constants"
import { BootScene } from "./scenes/boot-scene"
import { BossCutsceneScene } from "./scenes/boss-cutscene-scene"
import { CharacterSelectScene } from "./scenes/character-select-scene"
import { DebugScene } from "./scenes/debug-scene"
import { GameOverScene } from "./scenes/game-over-scene"
import { HudScene } from "./scenes/hud-scene"
import { MenuScene } from "./scenes/menu-scene"
import { OptionsScene } from "./scenes/options-scene"
import { PauseScene } from "./scenes/pause-scene"
import { SectorClearScene } from "./scenes/sector-clear-scene"
import { ShopScene } from "./scenes/shop-scene"
import { TutorialScene } from "./scenes/tutorial-scene"
import { UpgradeChoiceScene } from "./scenes/upgrade-choice-scene"
import { WaveScene } from "./scenes/wave-scene"

const DEBUG_MODE = false

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "phaser-container",
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    expandParent: false,
    fullscreenTarget: "phaser-container",
  },
  physics: {
    default: "arcade",
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: DEBUG_MODE,
    },
  },
  render: {
    pixelArt: true,
    antialias: false,
    roundPixels: true,
  },
  backgroundColor: THEME.colors.bgText,
  scene: [
    BootScene,
    MenuScene,
    TutorialScene,
    CharacterSelectScene,
    WaveScene,
    HudScene,
    BossCutsceneScene,
    SectorClearScene,
    ShopScene,
    PauseScene,
    UpgradeChoiceScene,
    GameOverScene,
    OptionsScene,
    DebugScene,
  ],
  input: {
    gamepad: true,
    touch: {
      capture: true,
    },
  },
}
